import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Upload,
  message,
  Progress,
  Button,
  Avatar,
  Typography,
  Tag,
  Space,
  Modal,
  Popconfirm,
  Input,
} from "antd";

import ReactCountryFlag from "react-country-flag";
import gender_male_icon from "../assets/images/gender_male_icon.png";
import gender_male2_icon from "../assets/images/gender_male2_icon.png";
import gender_female_icon from "../assets/images/gender_female_icon.png";
import gender_unknown_icon from "../assets/images/gender_uknown_icon.png";

import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useCallback, useRef } from "react";
import {
  activateUserAccounts,
  approveUserAccounts,
  deactivateUserAccounts,
  deleteUserAccounts,
  loadUsers,
  updateUserTajneed,
  resendEmailVerification,
  setEmailVerified,
  resetUserTwoFactor,
} from "../store/app/app.slice";
import moment from "moment";
import {
  UserDataDto,
  UserDataDtoGenderEnum,
  UserDataDetailsDto,
} from "acc-rest-client";
import EditUser from "../components/dialogs/EditUser";
import ManageRolesModal from "../components/dialogs/ManageRolesModal";
import {
  getCustomUnicodeFlagIcon,
  getUserStatusLabel,
  userStatusFilterDropdown,
} from "../utils/labelHelper";
import { getAuthenticatedUser } from "../utils/authHelper";

const { Title } = Typography;

const statusTemplate = (user) => {
  switch (user.approvalStatus) {
    case "NEW_REGISTERED_ACCOUNT":
      if (!user.emailVerified) {
        return (
          <div align={"center"}>
            <Tag
              style={{ width: "100%" }}
              icon={<ExclamationCircleOutlined />}
              color="warning"
            >
              Unverified
            </Tag>
          </div>
        );
      } else {
        return (
          <div align={"center"}>
            <Tag
              style={{ width: "100%" }}
              icon={<ExclamationCircleOutlined />}
              color="default"
            >
              Tajneed missing
            </Tag>
          </div>
        );
      }
    case "APPROVAL_RQUESTED":
      return (
        <div align={"center"}>
          <Tag
            style={{ width: "100%" }}
            icon={<ClockCircleOutlined />}
            color="processing"
          >
            {getUserStatusLabel(user)}
          </Tag>
        </div>
      );
    case "APPROVED":
      return (
        <div align={"center"}>
          <Tag
            style={{ width: "100%" }}
            icon={<CheckCircleOutlined />}
            color="success"
          >
            {getUserStatusLabel(user)}
          </Tag>
        </div>
      );
    case "REJECTED":
      return (
        <div align={"center"}>
          <Tag
            style={{ width: "100%" }}
            icon={<MinusCircleOutlined />}
            color="error"
          >
            {getUserStatusLabel(user)}
          </Tag>
        </div>
      );
    case "DEACTIVATED":
      return (
        <div align={"center"}>
          <Tag
            style={{ width: "100%" }}
            icon={<MinusCircleOutlined />}
            color="error"
          >
            {getUserStatusLabel(user)}
          </Tag>
        </div>
      );
    default:
      return "N/A";
  }
};

function Members() {
  const dispatch = useDispatch();
  const { users, usersPage, isUserLoading } = useSelector((state) => state.app);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [openRolesDialog, setOpenRolesDialog] = useState(false);
  const [rolesUser, setRolesUser] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const canManageRoles = getAuthenticatedUser()?.isRolesManager();
  const [statusFilter, setStatusFilter] = useState(["APPROVAL_RQUESTED"]);
  const [searchText, setSearchText] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [jamaatFilter, setJamaatFilter] = useState(null);
  const [countryFilter, setCountryFilter] = useState(null);
  const [dateOfBirthFilter, setDateOfBirthFilter] = useState(null);
  const [addressFilter, setAddressFilter] = useState(null);
  const [urduNameFilter, setUrduNameFilter] = useState(null);
  const [firstNameFilter, setFirstNameFilter] = useState(null);
  const [lastNameFilter, setLastNameFilter] = useState(null);
  const [emailFilter, setEmailFilter] = useState(null);
  const [aimsIdFilter, setAimsIdFilter] = useState(null);
  const [cityFilter, setCityFilter] = useState(null);
  const [zipCodeFilter, setZipCodeFilter] = useState(null);
  const [stateFilterAddr, setStateFilterAddr] = useState(null);
  const [streetLine1Filter, setStreetLine1Filter] = useState(null);
  const [streetLine2Filter, setStreetLine2Filter] = useState(null);
  const [contactNumberFilter, setContactNumberFilter] = useState(null);
  const [genderFilter, setGenderFilter] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  const loadUsersData = useCallback(
    (
      page,
      size,
      search,
      filters,
      jamaat,
      country,
      dateOfBirth,
      address,
      urduName,
      firstName,
      lastName,
      email,
      aimsId,
      city,
      zipCode,
      state,
      streetLine1,
      streetLine2,
      contactNumber,
      gender
    ) => {
      dispatch(
        loadUsers({
          search: search || "",
          statusFilters: filters && filters.length > 0 ? filters : null,
          jamaat: jamaat || null,
          country: country || null,
          dateOfBirth: dateOfBirth || null,
          address: address || null,
          urduName: urduName || null,
          firstName: firstName || null,
          lastName: lastName || null,
          email: email || null,
          aimsId: aimsId || null,
          city: city || null,
          zipCode: zipCode || null,
          state: state || null,
          streetLine1: streetLine1 || null,
          streetLine2: streetLine2 || null,
          contactNumber: contactNumber || null,
          gender: gender || null,
          page: page,
          size: size,
        })
      );
    },
    [dispatch]
  );

  // Use ref to track if component has mounted to ensure initial load
  const hasMounted = useRef(false);

  useEffect(() => {
    let totalElements = usersPage?.totalElements || 0;
    setTotalCount(totalElements)
  }, [usersPage]);
  
  // Load data when any filter, page, pageSize, or searchText changes
  useEffect(() => {
    console.log("useEffect triggered - loading users", {
      currentPage,
      pageSize,
      statusFilter,
      searchText,
    });
    // When text search is active, don't use attribute filters
    if (searchText) {
      loadUsersData(
        currentPage,
        pageSize,
        searchText,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
    } else {
      loadUsersData(
        currentPage,
        pageSize,
        "",
        statusFilter,
        jamaatFilter,
        countryFilter,
        dateOfBirthFilter,
        addressFilter,
        urduNameFilter,
        firstNameFilter,
        lastNameFilter,
        emailFilter,
        aimsIdFilter,
        cityFilter,
        zipCodeFilter,
        stateFilterAddr,
        streetLine1Filter,
        streetLine2Filter,
        contactNumberFilter,
        genderFilter
      );
    }
    hasMounted.current = true;
  }, [
    currentPage,
    pageSize,
    statusFilter,
    jamaatFilter,
    countryFilter,
    dateOfBirthFilter,
    addressFilter,
    urduNameFilter,
    firstNameFilter,
    lastNameFilter,
    emailFilter,
    aimsIdFilter,
    cityFilter,
    zipCodeFilter,
    stateFilterAddr,
    streetLine1Filter,
    streetLine2Filter,
    contactNumberFilter,
    genderFilter,
    searchText,
    loadUsersData,
  ]);

  const handleSearch = () => {
    setCurrentPage(0);
    // Clear all attribute filters when using text search
    setJamaatFilter(null);
    setCountryFilter(null);
    setDateOfBirthFilter(null);
    setAddressFilter(null);
    setUrduNameFilter(null);
    setFirstNameFilter(null);
    setLastNameFilter(null);
    setEmailFilter(null);
    setAimsIdFilter(null);
    setCityFilter(null);
    setZipCodeFilter(null);
    setStateFilterAddr(null);
    setStreetLine1Filter(null);
    setStreetLine2Filter(null);
    setContactNumberFilter(null);
    setGenderFilter(null);
    setStatusFilter([]);
    loadUsersData(
      0,
      pageSize,
      searchText,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );
  };

  const showModalEditUser = (currentUser) => {
    setCurrentUser(currentUser);
    setOpenEditDialog(true);
  };

  const showRolesModal = (user) => {
    setRolesUser(user);
    setOpenRolesDialog(true);
  };

  const hideRolesModal = () => {
    setRolesUser(null);
    setOpenRolesDialog(false);
  };

  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const hasUserRequestedApproval = () => {
    if (currentUser) {
      switch (currentUser.approvalStatus) {
        case "APPROVAL_RQUESTED":
          return true;
      }
    }

    return false;
  };

  const handleOk = () => {
    if (hasUserRequestedApproval()) {
      setLoading(true);
      message.loading({
        content: "Approving User Account...",
        key: currentUser.id,
      });
      dispatch(
        approveUserAccounts({
          finalData: {
            users: [currentUser],
          },
          callbackSuccess: (updatedUsers: UserDataDto[]) => {
            console.log(updatedUsers);
            if (searchText) {
              loadUsersData(
                currentPage,
                pageSize,
                searchText,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
              );
            } else {
              loadUsersData(
                currentPage,
                pageSize,
                "",
                statusFilter,
                jamaatFilter,
                countryFilter,
                dateOfBirthFilter,
                addressFilter,
                urduNameFilter,
                firstNameFilter,
                lastNameFilter,
                emailFilter,
                aimsIdFilter,
                cityFilter,
                zipCodeFilter,
                stateFilterAddr,
                streetLine1Filter,
                streetLine2Filter,
                contactNumberFilter,
                genderFilter
              );
            }
            setLoading(false);
            message.success({
              content: "User Account activated!!",
              key: currentUser.id,
              duration: 3,
            });
          },
          callbackError: (error: any) => {
            console.log(error);
            message.error({
              content: "Approving User Account failed: " + error,
              key: currentUser.id,
              duration: 10,
            });
            setLoading(false);
          },
        })
      );
    }
  };

  const handleDeactivate = (currentUser) => {
    setLoading(true);
    message.loading({
      content: "Deactivating User Account...",
      key: currentUser.id,
    });
    dispatch(
      deactivateUserAccounts({
        finalData: {
          users: [currentUser],
        },
        callbackSuccess: (updatedUsers: UserDataDto[]) => {
          console.log(updatedUsers);
          if (searchText) {
            loadUsersData(
              currentPage,
              pageSize,
              searchText,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null
            );
          } else {
            loadUsersData(
              currentPage,
              pageSize,
              "",
              statusFilter,
              jamaatFilter,
              countryFilter,
              dateOfBirthFilter,
              addressFilter,
              urduNameFilter,
              firstNameFilter,
              lastNameFilter,
              emailFilter,
              aimsIdFilter,
              cityFilter,
              zipCodeFilter,
              stateFilterAddr,
              streetLine1Filter,
              streetLine2Filter,
              contactNumberFilter,
              genderFilter
            );
          }
          setLoading(false);
          message.success({
            content: "User Account deactivated!!",
            key: currentUser.id,
            duration: 3,
          });
        },
        callbackError: (error: any) => {
          console.log(error);
          message.error({
            content: "Deactivating User Account failed: " + error,
            key: currentUser.id,
            duration: 10,
          });
          setLoading(false);
        },
      })
    );
  };

  const handleActivate = (currentUser) => {
    setLoading(true);
    message.loading({
      content: "Activating User Account...",
      key: currentUser.id,
    });
    dispatch(
      activateUserAccounts({
        finalData: {
          users: [currentUser],
        },
        callbackSuccess: (updatedUsers: UserDataDto[]) => {
          console.log(updatedUsers);
          dispatch(loadUsers({}));
          setLoading(false);
          message.success({
            content: "User Account activated!!",
            key: currentUser.id,
            duration: 3,
          });
        },
        callbackError: (error: any) => {
          console.log(error);
          message.error({
            content: "Activating User Account failed: " + error,
            key: currentUser.id,
            duration: 10,
          });
          setLoading(false);
        },
      })
    );
  };

  const handleReject = (currentUser) => {
    setLoading(true);
    message.loading({
      content: "Deleting User Account...",
      key: currentUser.id,
    });
    dispatch(
      deleteUserAccounts({
        finalData: {
          users: [currentUser],
        },
        callbackSuccess: (updatedUsers: UserDataDto[]) => {
          console.log(updatedUsers);
          dispatch(loadUsers({}));
          setLoading(false);
          message.success({
            content: "User Account deleted!!",
            key: currentUser.id,
            duration: 3,
          });
        },
        callbackError: (error: any) => {
          console.log(error);
          message.error({
            content: "Deleting User Account failed: " + error,
            key: currentUser.id,
            duration: 10,
          });
          setLoading(false);
        },
      })
    );
  };

  const handleResendVerificationEmail = (user) => {
    setLoading(true);
    message.loading({
      content: "Resending verification email...",
      key: user.id,
    });
    dispatch(
      resendEmailVerification({
        userId: user.id,
        callbackSuccess: (response) => {
          setLoading(false);
          message.success({
            content: "Verification email sent!",
            key: user.id,
            duration: 3,
          });
        },
        callbackError: (error) => {
          setLoading(false);
          message.error({
            content: "Failed to resend verification email: " + error,
            key: user.id,
            duration: 10,
          });
        },
      })
    );
  };

  const handleSetEmailVerified = (user) => {
    setLoading(true);
    message.loading({ content: "Setting email as verified...", key: user.id });
    dispatch(
      setEmailVerified({
        userId: user.id,
        callbackSuccess: (response) => {
          if (searchText) {
            loadUsersData(
              currentPage,
              pageSize,
              searchText,
              null,
              null,
              null,
              null,
              null,
              null
            );
          } else {
            loadUsersData(
              currentPage,
              pageSize,
              "",
              statusFilter,
              jamaatFilter,
              countryFilter,
              dateOfBirthFilter,
              addressFilter,
              urduNameFilter
            );
          }
          setLoading(false);
          message.success({
            content: "Email marked as verified!",
            key: user.id,
            duration: 3,
          });
        },
        callbackError: (error) => {
          setLoading(false);
          message.error({
            content: "Failed to set email as verified: " + error,
            key: user.id,
            duration: 10,
          });
        },
      })
    );
  };

  const handleResetTwoFactor = (user) => {
    setLoading(true);
    message.loading({ content: "Resetting two-factor authentication...", key: user.id });
    dispatch(
      resetUserTwoFactor({
        userId: user.id,
        callbackSuccess: (response) => {
          setLoading(false);
          message.success({
            content:
              response?.message ||
              "2FA reset! The member must set it up again on next login.",
            key: user.id,
            duration: 4,
          });
        },
        callbackError: (error) => {
          setLoading(false);
          message.error({
            content: "Failed to reset 2FA: " + error,
            key: user.id,
            duration: 10,
          });
        },
      })
    );
  };

  const deleteConfirmPopUp = (user) => {
    return (
      <Popconfirm
        title="Are you sure you want to delete this User? There is no option to undo this action."
        onConfirm={() => {
          handleReject(user);
        }}
        okText="Yes"
        cancelText="No"
      >
        Delete
      </Popconfirm>
    );
  };

  const editTemplate = (user: UserDataDto, showModalEditUser) => {
    switch (user.approvalStatus) {
      case "NEW_REGISTERED_ACCOUNT":
        if (!user.emailVerified) {
          return (
            <Space direction={"vertical"}>
              <Button
                style={{ width: "100%" }}
                type="primary"
                className="tag-primary"
                onClick={() => showModalEditUser(user)}
              >
                Update & Approve
              </Button>
              <Button
                style={{ width: "100%" }}
                type="default"
                className="ant-tag-warning"
                onClick={() => handleResendVerificationEmail(user)}
              >
                Resend Verification Email
              </Button>
              <Button
                style={{ width: "100%" }}
                type="default"
                className="ant-tag-success"
                onClick={() => handleSetEmailVerified(user)}
              >
                Set Email Verified
              </Button>
              <Button
                style={{ width: "100%" }}
                type="default"
                className="ant-tag-error"
              >
                {deleteConfirmPopUp(user)}
              </Button>
            </Space>
          );
        } else {
          return (
            <Space direction={"vertical"}>
              <Button
                style={{ width: "100%" }}
                type="primary"
                className="tag-primary"
                onClick={() => showModalEditUser(user)}
              >
                Update & Approve
              </Button>
              <Button
                style={{ width: "100%" }}
                type="default"
                className="ant-tag-error"
              >
                {deleteConfirmPopUp(user)}
              </Button>
            </Space>
          );
        }
      case "APPROVAL_RQUESTED":
        return (
          <Space direction={"vertical"}>
            <Button
              style={{ width: "100%" }}
              type="primary"
              className="tag-primary"
              onClick={() => showModalEditUser(user)}
            >
              Approve
            </Button>
            <Button
              style={{ width: "100%" }}
              type="default"
              className="ant-tag-error"
            >
              {deleteConfirmPopUp(user)}
            </Button>
          </Space>
        );
      case "APPROVED":
        return (
          <Space direction={"vertical"}>
            <Button
              style={{ width: "100%" }}
              type="primary"
              className="tag-primary"
              onClick={() => showModalEditUser(user)}
            >
              Edit
            </Button>
            {canManageRoles && (
              <Button
                style={{ width: "100%" }}
                type="default"
                onClick={() => showRolesModal(user)}
              >
                Manage Roles
              </Button>
            )}
            {user.twoFactorEnabled && (
              <Button
                style={{ width: "100%" }}
                type="default"
                className="ant-tag-warning"
              >
                <Popconfirm
                  title="Reset this member's two-factor authentication (2FA)? They will have to set it up again on their next login. Their password stays unchanged."
                  onConfirm={() => {
                    handleResetTwoFactor(user);
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  Reset 2FA
                </Popconfirm>
              </Button>
            )}
            <Button
              style={{ width: "100%" }}
              type="default"
              className="ant-tag-error"
            >
              <Popconfirm
                title="Are you sure you want to deactivate this User? You can reactivate this User later."
                onConfirm={() => {
                  handleDeactivate(user);
                }}
                okText="Yes"
                cancelText="No"
              >
                Deactivate
              </Popconfirm>
            </Button>
          </Space>
        );
      case "REJECTED":
        return (
          <Space direction={"vertical"}>
            <Button
              style={{ width: "100%" }}
              type="primary"
              className="tag-primary"
              onClick={() => showModalEditUser(user)}
            >
              Activate
            </Button>
            <Button
              style={{ width: "100%" }}
              type="default"
              className="ant-tag-error"
            >
              {deleteConfirmPopUp(user)}
            </Button>
          </Space>
        );
      case "DEACTIVATED":
        return (
          <Space direction={"vertical"}>
            <Button
              style={{ width: "100%" }}
              type="default"
              className="ant-tag-success"
            >
              <Popconfirm
                title="Are you sure you want to activate this User?"
                onConfirm={() => {
                  handleActivate(user);
                }}
                okText="Yes"
                cancelText="No"
              >
                Activate
              </Popconfirm>
            </Button>
            <Button
              style={{ width: "100%" }}
              type="default"
              className="ant-tag-error"
            >
              {deleteConfirmPopUp(user)}
            </Button>
          </Space>
        );
      default:
    }
  };

  const hideModalEditUser = () => {
    setCurrentUser(null);
    setOpenEditDialog(false);
  };

  const columns = [
    {
      id: 1,
      hidden: false,
      title: "Member",
      dataIndex: "",
      //Add sorter
      sorter: (a: UserDataDto, b: UserDataDto) =>
        a.firstName?.localeCompare(b.firstName),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        // Initialize selectedKeys from filter state when dropdown opens
        // Use filter state as source of truth, selectedKeys for temporary editing
        const initialValues = [
          firstNameFilter || "",
          lastNameFilter || "",
          emailFilter || "",
          genderFilter || "",
        ];
        const currentValues =
          selectedKeys && selectedKeys.length === 4
            ? selectedKeys
            : initialValues;

        // Only initialize if selectedKeys is empty or doesn't match filter state
        if (
          !selectedKeys ||
          selectedKeys.length === 0 ||
          selectedKeys[0] !== initialValues[0] ||
          selectedKeys[1] !== initialValues[1] ||
          selectedKeys[2] !== initialValues[2] ||
          selectedKeys[3] !== initialValues[3]
        ) {
          // Only set if user hasn't started typing (selectedKeys is empty or matches old filter state)
          if (
            !selectedKeys ||
            selectedKeys.length === 0 ||
            (selectedKeys[0] === (firstNameFilter || "") &&
              selectedKeys[1] === (lastNameFilter || "") &&
              selectedKeys[2] === (emailFilter || "") &&
              selectedKeys[3] === (genderFilter || ""))
          ) {
            setSelectedKeys(initialValues);
          }
        }

        const firstNameValue = currentValues[0] || "";
        const lastNameValue = currentValues[1] || "";
        const emailValue = currentValues[2] || "";
        const genderValue = currentValues[3] || "";

        return (
          <div style={{ padding: 8 }}>
            <Input
              placeholder="Filter First Name"
              value={firstNameValue}
              onChange={(e) =>
                setSelectedKeys([
                  e.target.value,
                  lastNameValue,
                  emailValue,
                  genderValue,
                ])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter Last Name"
              value={lastNameValue}
              onChange={(e) =>
                setSelectedKeys([
                  firstNameValue,
                  e.target.value,
                  emailValue,
                  genderValue,
                ])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter Email"
              value={emailValue}
              onChange={(e) =>
                setSelectedKeys([
                  firstNameValue,
                  lastNameValue,
                  e.target.value,
                  genderValue,
                ])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter Gender (MALE/FEMALE)"
              value={genderValue}
              onChange={(e) =>
                setSelectedKeys([
                  firstNameValue,
                  lastNameValue,
                  emailValue,
                  e.target.value,
                ])
              }
              onPressEnter={() => {
                confirm();
                setFirstNameFilter(firstNameValue || null);
                setLastNameFilter(lastNameValue || null);
                setEmailFilter(emailValue || null);
                setGenderFilter(genderValue || null);
                setSearchText("");
                setCurrentPage(0);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  confirm();
                  setFirstNameFilter(firstNameValue || null);
                  setLastNameFilter(lastNameValue || null);
                  setEmailFilter(emailValue || null);
                  setGenderFilter(genderValue || null);
                  setSearchText("");
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                  clearFilters();
                  setSelectedKeys([]);
                  setFirstNameFilter(null);
                  setLastNameFilter(null);
                  setEmailFilter(null);
                  setGenderFilter(null);
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        );
      },
      filteredValue:
        firstNameFilter || lastNameFilter || emailFilter || genderFilter
          ? [
              firstNameFilter || "",
              lastNameFilter || "",
              emailFilter || "",
              genderFilter || "",
            ].filter((v) => v)
          : null,
      render: (user) =>
        user ? (
          <Avatar.Group>
            <div style={{ marginRight: "3px" }}>
              <Avatar
                src={
                  user.gender
                    ? user.gender === UserDataDtoGenderEnum.Male
                      ? gender_male2_icon
                      : user.gender === UserDataDtoGenderEnum.Female
                      ? gender_female_icon
                      : gender_unknown_icon
                    : gender_unknown_icon
                }
                shape="square"
                size="large"
              >
                {user.gender}
              </Avatar>
            </div>
            <div className="avatar-info">
              <Title level={5}>{user.firstName + " " + user.lastName}</Title>
              <p>{user.email}</p>
            </div>
          </Avatar.Group>
        ) : (
          "N/A"
        ),
    },
    {
      id: 2,
      hidden: false,
      title: "Urdu Name",
      dataIndex: "",
      sorter: (a: UserDataDto, b: UserDataDto) =>
        a.urduName?.localeCompare(b.urduName),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        // Initialize selectedKeys from filter state when dropdown opens
        const initialValue = urduNameFilter || "";
        const currentValue =
          selectedKeys && selectedKeys.length > 0
            ? selectedKeys[0]
            : initialValue;

        if (
          !selectedKeys ||
          selectedKeys.length === 0 ||
          selectedKeys[0] !== initialValue
        ) {
          if (!selectedKeys || selectedKeys.length === 0) {
            setSelectedKeys([initialValue]);
          }
        }

        const urduNameValue = currentValue;

        return (
          <div style={{ padding: 8 }}>
            <Input
              placeholder="Filter Urdu Name"
              value={urduNameValue}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => {
                confirm();
                const filterValue = urduNameValue || null;
                setUrduNameFilter(filterValue);
                setSearchText(""); // Clear text search when using column filter
                setCurrentPage(0);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  confirm();
                  const filterValue = urduNameValue || null;
                  setUrduNameFilter(filterValue);
                  setSearchText(""); // Clear text search when using column filter
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                  clearFilters();
                  setUrduNameFilter(null);
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        );
      },
      filteredValue: urduNameFilter ? [urduNameFilter] : null,
      // No onFilter - filtering is done server-side
      render: (user) =>
        user ? (
          <div className="author-info">
            <p>{user.urduName || " - "}</p>
          </div>
        ) : (
          "N/A"
        ),
    },
    {
      id: 3,
      hidden: false,
      title: "Jamaat",
      dataIndex: "",
      sorter: (a: UserDataDto, b: UserDataDto) =>
        a.jamaat?.localeCompare(b.jamaat),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        // Initialize selectedKeys from filter state when dropdown opens
        const initialValues = [
          jamaatFilter || "",
          countryFilter || "",
          aimsIdFilter || "",
        ];
        const currentValues =
          selectedKeys && selectedKeys.length === 3
            ? selectedKeys
            : initialValues;

        if (
          !selectedKeys ||
          selectedKeys.length === 0 ||
          selectedKeys[0] !== initialValues[0] ||
          selectedKeys[1] !== initialValues[1] ||
          selectedKeys[2] !== initialValues[2]
        ) {
          if (!selectedKeys || selectedKeys.length === 0) {
            setSelectedKeys(initialValues);
          }
        }

        const jamaatValue = currentValues[0] || "";
        const countryValue = currentValues[1] || "";
        const aimsIdValue = currentValues[2] || "";

        return (
          <div style={{ padding: 8 }}>
            <Input
              placeholder="Filter Jamaat"
              value={jamaatValue}
              onChange={(e) =>
                setSelectedKeys([e.target.value, countryValue, aimsIdValue])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter Country"
              value={countryValue}
              onChange={(e) =>
                setSelectedKeys([jamaatValue, e.target.value, aimsIdValue])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter AIMS ID"
              value={aimsIdValue}
              onChange={(e) =>
                setSelectedKeys([jamaatValue, countryValue, e.target.value])
              }
              onPressEnter={() => {
                confirm();
                setJamaatFilter(jamaatValue || null);
                setCountryFilter(countryValue || null);
                setAimsIdFilter(aimsIdValue || null);
                setSearchText(""); // Clear text search when using column filter
                setCurrentPage(0);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  confirm();
                  setJamaatFilter(jamaatValue || null);
                  setCountryFilter(countryValue || null);
                  setAimsIdFilter(aimsIdValue || null);
                  setSearchText(""); // Clear text search when using column filter
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                  clearFilters();
                  setSelectedKeys([]);
                  setJamaatFilter(null);
                  setCountryFilter(null);
                  setAimsIdFilter(null);
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        );
      },
      filteredValue:
        jamaatFilter || countryFilter || aimsIdFilter
          ? [
              jamaatFilter || "",
              countryFilter || "",
              aimsIdFilter || "",
            ].filter((v) => v)
          : null,
      // No onFilter - filtering is done server-side
      render: (user) =>
        user ? (
          <div className="author-info">
            <p>{user.aimsId}</p>
            <p>
              <span>
                {user?.jamaat ? user.jamaat : ""}
                <br />
                {user?.country ? user.country.defaultLabel : ""}&nbsp;
                {getCustomUnicodeFlagIcon(user?.country?.values?.flag)}
              </span>
            </p>
          </div>
        ) : (
          "N/A"
        ),
    },
    {
      id: 4,
      hidden: false,
      title: "Date of Birth",
      dataIndex: "",
      sorter: (a: UserDataDto, b: UserDataDto) =>
        a.birthdate?.localeCompare(b.birthdate),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        // Initialize selectedKeys from filter state when dropdown opens
        const initialValue = dateOfBirthFilter || "";
        const currentValue =
          selectedKeys && selectedKeys.length > 0
            ? selectedKeys[0]
            : initialValue;

        if (
          !selectedKeys ||
          selectedKeys.length === 0 ||
          selectedKeys[0] !== initialValue
        ) {
          if (!selectedKeys || selectedKeys.length === 0) {
            setSelectedKeys([initialValue]);
          }
        }

        const dateOfBirthValue = currentValue;

        return (
          <div style={{ padding: 8 }}>
            <Input
              placeholder="Filter Date (DD.MM.yyyy)"
              value={dateOfBirthValue}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => {
                confirm();
                const filterValue = dateOfBirthValue || null;
                setDateOfBirthFilter(filterValue);
                setSearchText(""); // Clear text search when using column filter
                setCurrentPage(0);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  confirm();
                  const filterValue = dateOfBirthValue || null;
                  setDateOfBirthFilter(filterValue);
                  setSearchText(""); // Clear text search when using column filter
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                  clearFilters();
                  setDateOfBirthFilter(null);
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        );
      },
      filteredValue: dateOfBirthFilter ? [dateOfBirthFilter] : null,
      // No onFilter - filtering is done server-side
      render: (user) =>
        user ? (
          <div className="author-info">
            <p>
              {user.birthdate
                ? moment(user.birthdate).format("DD.MM.yyyy")
                : " "}
            </p>
          </div>
        ) : (
          "N/A"
        ),
    },
    {
      id: 5,
      hidden: false,
      title: "Address",
      dataIndex: "",
      //sorter: (a, b) => a.projectType?.translations?.en?.localeCompare(b.projectType?.translations?.en),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        // Initialize selectedKeys from filter state when dropdown opens
        const initialValues = [
          streetLine1Filter || "",
          streetLine2Filter || "",
          cityFilter || "",
          zipCodeFilter || "",
          stateFilterAddr || "",
          contactNumberFilter || "",
        ];
        const currentValues =
          selectedKeys && selectedKeys.length === 6
            ? selectedKeys
            : initialValues;

        if (
          !selectedKeys ||
          selectedKeys.length === 0 ||
          selectedKeys[0] !== initialValues[0] ||
          selectedKeys[1] !== initialValues[1] ||
          selectedKeys[2] !== initialValues[2] ||
          selectedKeys[3] !== initialValues[3] ||
          selectedKeys[4] !== initialValues[4] ||
          selectedKeys[5] !== initialValues[5]
        ) {
          if (!selectedKeys || selectedKeys.length === 0) {
            setSelectedKeys(initialValues);
          }
        }

        const streetLine1Value = currentValues[0] || "";
        const streetLine2Value = currentValues[1] || "";
        const cityValue = currentValues[2] || "";
        const zipCodeValue = currentValues[3] || "";
        const stateValue = currentValues[4] || "";
        const contactNumberValue = currentValues[5] || "";

        return (
          <div style={{ padding: 8 }}>
            <Input
              placeholder="Filter Street Line 1"
              value={streetLine1Value}
              onChange={(e) =>
                setSelectedKeys([
                  e.target.value,
                  streetLine2Value,
                  cityValue,
                  zipCodeValue,
                  stateValue,
                  contactNumberValue,
                ])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter Street Line 2"
              value={streetLine2Value}
              onChange={(e) =>
                setSelectedKeys([
                  streetLine1Value,
                  e.target.value,
                  cityValue,
                  zipCodeValue,
                  stateValue,
                  contactNumberValue,
                ])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter City"
              value={cityValue}
              onChange={(e) =>
                setSelectedKeys([
                  streetLine1Value,
                  streetLine2Value,
                  e.target.value,
                  zipCodeValue,
                  stateValue,
                  contactNumberValue,
                ])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter ZIP Code"
              value={zipCodeValue}
              onChange={(e) =>
                setSelectedKeys([
                  streetLine1Value,
                  streetLine2Value,
                  cityValue,
                  e.target.value,
                  stateValue,
                  contactNumberValue,
                ])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter State"
              value={stateValue}
              onChange={(e) =>
                setSelectedKeys([
                  streetLine1Value,
                  streetLine2Value,
                  cityValue,
                  zipCodeValue,
                  e.target.value,
                  contactNumberValue,
                ])
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Input
              placeholder="Filter Contact Number"
              value={contactNumberValue}
              onChange={(e) =>
                setSelectedKeys([
                  streetLine1Value,
                  streetLine2Value,
                  cityValue,
                  zipCodeValue,
                  stateValue,
                  e.target.value,
                ])
              }
              onPressEnter={() => {
                confirm();
                setStreetLine1Filter(streetLine1Value || null);
                setStreetLine2Filter(streetLine2Value || null);
                setCityFilter(cityValue || null);
                setZipCodeFilter(zipCodeValue || null);
                setStateFilterAddr(stateValue || null);
                setContactNumberFilter(contactNumberValue || null);
                setSearchText("");
                setCurrentPage(0);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  confirm();
                  setStreetLine1Filter(streetLine1Value || null);
                  setStreetLine2Filter(streetLine2Value || null);
                  setCityFilter(cityValue || null);
                  setZipCodeFilter(zipCodeValue || null);
                  setStateFilterAddr(stateValue || null);
                  setContactNumberFilter(contactNumberValue || null);
                  setSearchText("");
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                  clearFilters();
                  setSelectedKeys([]);
                  setStreetLine1Filter(null);
                  setStreetLine2Filter(null);
                  setCityFilter(null);
                  setZipCodeFilter(null);
                  setStateFilterAddr(null);
                  setContactNumberFilter(null);
                  setCurrentPage(0);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        );
      },
      filteredValue:
        streetLine1Filter ||
        streetLine2Filter ||
        cityFilter ||
        zipCodeFilter ||
        stateFilterAddr
          ? [
              streetLine1Filter || "",
              streetLine2Filter || "",
              cityFilter || "",
              zipCodeFilter || "",
              stateFilterAddr || "",
            ].filter((v) => v)
          : null,
      // No onFilter - filtering is done server-side
      render: (user) =>
        user ? (
          <div className="author-info">
            <p>{user.streetLine1}</p>
            <p>{user.streetLine2}</p>
            <p>
              {user.zipCode} {user.city}{" "}
              {user.state ? "(" + user.state + ")" : ""}
            </p>
          </div>
        ) : (
          "N/A"
        ),
    },
    {
      id: 8,
      hidden: false,
      title: "Status",
      dataIndex: "",
      sorter: (a, b) => a.approvalStatus?.localeCompare(b.approvalStatus),
      defaultSortOrder: "ascend",
      filters: userStatusFilterDropdown,
      filteredValue: statusFilter,
      // No onFilter - filtering is done server-side
      render: (user) => {
        const statusTag = statusTemplate(user);

        // Check for Auto Approved
        const autoApprovedTag =
          user.approverId === "System Auto Approval" ? (
            <div align={"center"}>
              <Tag
                style={{ width: "100%" }}
                icon={<ExclamationCircleOutlined />}
                color="orange"
              >
                AUTO APPROVED
              </Tag>
            </div>
          ) : null;

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {statusTag}
            {autoApprovedTag}
          </div>
        );
      },
    },
    {
      id: 13,
      hidden: false,
      title: "Created",
      dataIndex: "",
      sorter: (a: UserDataDto, b: UserDataDto) =>
        moment(a.createdTimestamp).unix() - moment(b.createdTimestamp).unix(),
      render: (user) =>
        user ? (
          <div align={"center"}>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "small",
              }}
            >
              {moment(user.createdTimestamp).format("DD.MM.yyyy - HH:mm:ss")}
            </p>
          </div>
        ) : (
          "N/A"
        ),
    },
  ];

  const actionColumn = {
    id: 14,
    hidden: false,
    title: "Action",
    dataIndex: "",
    //sorter: (a, b) => a.projectType?.translations?.en?.localeCompare(b.projectType?.translations?.en),
    render: (user) => (user ? editTemplate(user, showModalEditUser) : "N/A"),
    //filters: uniqueFilterData(projectTypeFilter),
    //onFilter: (value, record) => record?.projectType?.translations?.en?.includes(value),
  };

  const approvedByColumn = {
    id: 9,
    hidden: false,
    title: "Approved By",
    dataIndex: "",
    render: (user) => {
      if (user.approverId === "System Auto Approval") {
        return <Tag color="orange">AUTO APPROVED</Tag>;
      }

      if (user.approverId && Array.isArray(users)) {
        const approver = users.find((u) => u.id === user.approverId);
        if (approver) {
          return (
            <div className="author-info">
              <p>
                {" "}
                {approver.firstName} {approver.lastName}{" "}
              </p>
            </div>
          );
        } else {
          return <Tag color="red">Unknown</Tag>;
        }
      }

      // Kein approverId gesetzt
      return (
        <div className="author-info">
          <p>-</p>
        </div>
      );
    },
  };

  const approvalDateColumn = {
    id: 10,
    hidden: false,
    title: "Approval Date",
    dataIndex: "",
    sorter: (a: UserDataDetailsDto, b: UserDataDetailsDto) =>
      a.approvalDate?.localeCompare(b.approvalDate),
    render: (user) =>
      user ? (
        <div className="author-info">
          <p>
            {user.approvalDate
              ? moment(user.approvalDate).format("DD.MM.yyyy - HH:mm:ss")
              : " "}
          </p>
        </div>
      ) : (
        "N/A"
      ),
  };

  const tajneedUpdateDateColumn = {
    id: 11,
    hidden: false,
    title: "Tajneed Update Date",
    dataIndex: "",
    sorter: (a: UserDataDetailsDto, b: UserDataDetailsDto) =>
      a.tajneedUpdateDate?.localeCompare(b.tajneedUpdateDate),
    render: (user) =>
      user ? (
        <div className="author-info">
          <p>
            {user.tajneedUpdateDate
              ? moment(user.tajneedUpdateDate).format("DD.MM.yyyy - HH:mm:ss")
              : " "}
          </p>
        </div>
      ) : (
        "N/A"
      ),
  };

  const reminderTajneedDate = {
    id: 12,
    hidden: false,
    title: "Reminder Tajneed Date / Count",
    dataIndex: "",
    sorter: (a: UserDataDetailsDto, b: UserDataDetailsDto) =>
      a.reminderTajneedDate?.localeCompare(b.reminderTajneedDate),
    render: (user) => {
      if (!user) return "N/A";

      const date = user.reminderTajneedDate
        ? moment(user.reminderTajneedDate).format("DD.MM.yyyy - HH:mm:ss")
        : "-";

      const count =
        user.reminderTajneedCount !== undefined &&
        user.reminderTajneedCount !== null
          ? user.reminderTajneedCount
          : "-";

      return (
        <div className="author-info">
          <p>
            {" "}
            {date} / {count}{" "}
          </p>
        </div>
      );
    },
  };

  const reminderVerifyMailsDate = {
    id: 13,
    hidden: false,
    title: "Reminder Verify Mails Date / Count",
    dataIndex: "",
    sorter: (a: UserDataDetailsDto, b: UserDataDetailsDto) =>
      a.reminderVerifyMailsDate?.localeCompare(b.reminderVerifyMailsDate),
    render: (user) => {
      if (!user) return "N/A";

      const date = user.reminderVerifyMailsDate
        ? moment(user.reminderVerifyMailsDate).format("DD.MM.yyyy - HH:mm:ss")
        : "-";

      const count =
        user.reminderVerifyMailsCount !== undefined &&
        user.reminderVerifyMailsCount !== null
          ? user.reminderVerifyMailsCount
          : "-";

      return (
        <div className="author-info">
          <p>
            {" "}
            {date} / {count}{" "}
          </p>
        </div>
      );
    },
  };

  const getFilteredData = () => {
    if (!users) return [];
    if (!searchText) {
      return users.filter((user) => {
        if (!statusFilter?.length) return true;

        // Handle special filter cases
        if (statusFilter.includes("UNVERIFIED")) {
          return (
            user.approvalStatus === "NEW_REGISTERED_ACCOUNT" &&
            !user.emailVerified
          );
        }
        if (statusFilter.includes("TAJNEED_MISSING")) {
          return (
            user.approvalStatus === "NEW_REGISTERED_ACCOUNT" &&
            user.emailVerified
          );
        }

        // Handle regular status filters
        return statusFilter.includes(user.approvalStatus);
      });
    }
    return users.filter((user) => {
      return Object.values(user).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchText.toLowerCase())
      );
    });
  };

  useEffect(() => {
    if (searchText) {
      setStatusFilter([]);
    }
  }, [searchText]);

  let displayedColumns = [...columns];

  if (statusFilter?.length === 0) {
    displayedColumns.push(
      approvedByColumn,
      approvalDateColumn,
      tajneedUpdateDateColumn,
      reminderTajneedDate,
      reminderVerifyMailsDate
    );
  }
  if (statusFilter?.includes("APPROVED")) {
    displayedColumns.push(approvedByColumn, approvalDateColumn);
  } else if (statusFilter?.includes("APPROVAL_RQUESTED")) {
    displayedColumns.push(tajneedUpdateDateColumn, reminderTajneedDate);
  } else if (statusFilter?.includes("UNVERIFIED")) {
    displayedColumns.push(reminderVerifyMailsDate);
  }

  // Action btns column at last
  displayedColumns.push(actionColumn);

  // const totalCount = usersPage?.totalElements || 0;

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={`PSO App Users (${totalCount})`}
              extra={
                <Space>
                  <Input
                    placeholder="Search (username, email, name)..."
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      // Clear all column filters when typing in search
                      if (e.target.value) {
                        setJamaatFilter(null);
                        setCountryFilter(null);
                        setDateOfBirthFilter(null);
                        setAddressFilter(null);
                        setUrduNameFilter(null);
                        setFirstNameFilter(null);
                        setLastNameFilter(null);
                        setEmailFilter(null);
                        setAimsIdFilter(null);
                        setCityFilter(null);
                        setZipCodeFilter(null);
                        setStateFilterAddr(null);
                        setStreetLine1Filter(null);
                        setStreetLine2Filter(null);
                        setContactNumberFilter(null);
                        setGenderFilter(null);
                      }
                    }}
                    onPressEnter={handleSearch}
                    style={{ width: 200 }}
                  />
                  <Radio.Group
                    onChange={onChange}
                    defaultValue="PENDING"
                    buttonStyle="solid"
                    value={
                      statusFilter?.length === 0
                        ? "all"
                        : statusFilter?.length === 1
                        ? statusFilter[0]
                        : "none"
                    }
                    disabled={!!searchText}
                  >
                    <Radio.Button
                      checked={statusFilter?.includes("APPROVAL_REQUESTED")}
                      onClick={() => setStatusFilter(["APPROVAL_RQUESTED"])}
                      value="APPROVAL_RQUESTED"
                    >
                      PENDING
                    </Radio.Button>
                    <Radio.Button
                      checked={statusFilter?.includes("UNVERIFIED")}
                      onClick={() => setStatusFilter(["UNVERIFIED"])}
                      value="UNVERIFIED"
                    >
                      UNVERIFIED
                    </Radio.Button>
                    <Radio.Button
                      checked={statusFilter?.includes("TAJNEED_MISSING")}
                      onClick={() => setStatusFilter(["TAJNEED_MISSING"])}
                      value="TAJNEED_MISSING"
                    >
                      TAJNEED MISSING
                    </Radio.Button>
                    <Radio.Button
                      onClick={() => setStatusFilter(["APPROVED"])}
                      value="APPROVED"
                    >
                      ACTIVE
                    </Radio.Button>
                    <Radio.Button
                      onClick={() => setStatusFilter(["DEACTIVATED"])}
                      value="DEACTIVATED"
                    >
                      INACTIVE
                    </Radio.Button>
                    <Radio.Button
                      onClick={() => setStatusFilter([])}
                      value="all"
                    >
                      ALL
                    </Radio.Button>
                  </Radio.Group>
                </Space>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={displayedColumns}
                  dataSource={getFilteredData()}
                  loading={isUserLoading}
                  pagination={{
                    current: currentPage + 1,
                    pageSize: pageSize,
                    total: totalCount,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    showTotal: (total, range) => {
                      return `${range[0]}-${range[1]} of ${total} items`;
                    },
                  }}
                  className="ant-border-space"
                  onChange={(pagination, filters, sorter, extra) => {
                    if (extra.action === "filter" && !searchText) {
                      // Handle status filter (column index 4)
                      if (filters[4] !== undefined) {
                        setStatusFilter(filters[4] || []);
                      }
                    }
                    if (extra.action === "paginate") {
                      // Update state - useEffect will trigger the data load
                      setCurrentPage(pagination.current - 1);
                      setPageSize(pagination.pageSize);
                    }
                  }}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        open={openEditDialog}
        key={currentUser?.id ? currentUser?.id : Math.random()}
        title="User Approval"
        onOk={handleOk}
        okButtonProps={{ disabled: !hasUserRequestedApproval() }}
        okText={"Approve User Account"}
        onCancel={hideModalEditUser}
        cancelText={"Close"}
        //width={1000}
      >
        <EditUser
          key={currentUser?.id ? currentUser?.id : Math.random()}
          user={currentUser}
        />
      </Modal>
      <ManageRolesModal
        open={openRolesDialog}
        user={rolesUser}
        onClose={hideRolesModal}
      />
    </>
  );
}

export default Members;
